import { SETTING_CHANGE_LANGUAGE } from "../../util/mutationTypes";

import { EVENT_CHANGE_LANGUAGE } from "../../util/eventType";

import { EventBus } from "../../util/eventBus";

export default {
  methods: {
    changeLanguage(lang) {
      let locale = lang.toUpperCase();
      if (Object.keys(this.$i18n.messages).indexOf(locale) !== -1) {
        if (this.$i18n.locale != locale) {
          this.$store.commit(SETTING_CHANGE_LANGUAGE, locale);
          this.$i18n.locale = locale;
          EventBus.$emit(EVENT_CHANGE_LANGUAGE);
        }
      }
    }
  }
};
